import {Injectable} from '@angular/core';
import {CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router} from '@angular/router';
import {Observable} from 'rxjs';
import {AuthenticationService} from '../services/authentication/authentication.service';
import {PermissionService} from '../services/permission/permission.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(private route: Router,
              private permissions: PermissionService,
              private auth: AuthenticationService) {
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (this.auth.isLoggedIn()) {

      /**
       * Will check all permissions
       */
      let allowed = true;
      const permissions = next.data?.permissions;
      if (Array.isArray(permissions)) {
        for (const permission of permissions) {
          if (!this.permissions.hasPermission(permission)) {
            allowed = false;
          }
        }
      }

      /**
       * Will check that at least one of permissions exist
       */
      const oneOfPermissions = next.data?.oneOfPermissions;
      if (Array.isArray(oneOfPermissions)) {
        allowed = false;
        for (const permission of oneOfPermissions) {
          if (this.permissions.hasPermission(permission)) {
            allowed = true;
          }
        }
      }

      if (!allowed) {
        this.route.navigate(['/dashboard']);
      }

      return allowed;
    } else if (this.auth.isLoggedInAmplify()) {
      this.route.navigate(['/as/overview']);
    } else {
      this.route.navigate(['/logout']);
      return false;
    }
  }
}
